exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comments[data-v-63c57dda] {\n  margin-bottom: 10px;\n}\n.comment[data-v-63c57dda] {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
